import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import FormWrapper from '../DynamicForm/FormWrapper';
import ScrollTo, { smoothScrollToRef } from '../ScrollTo';

const checkForms = (forms) => {
  let nonHiddenFields = [];
  let noForm = false;
  let valid = ['input', 'radioButtons'];
  for (let i = 0; i < forms.length; i++) {
    let form = forms[i];
    if (!form.childrenMarketoFormField) {
      noForm = true;
      break;
    }
    for (let j = 0; j < form.childrenMarketoFormField.length; j++) {
      let field = form.childrenMarketoFormField[j];
      if (valid.indexOf(field.dataType) > -1) {
        nonHiddenFields.push(field);
      }
    }
  }
  return !noForm && nonHiddenFields.length > 0;
};

const Form = ({ form = {}, programName, successMessage, followUpForms = [], onSuccess }) => {
  const [step, setStep] = useState(0);
  const topRef = useRef(null);
  let className = `current-step-${step}`;
  useEffect(() => (className = `current-step-${step}`), [step]);
  const useFollowups = checkForms(followUpForms || []);
  if (!followUpForms || !useFollowups) {
    return (
      <FormWrapper
        onSuccess={onSuccess}
        programName={form?.programName || form?.marketoProgramName || programName}
        form={form}
        fields={form.childrenMarketoFormField}
      />
    );
  }

  let forms = [form, ...followUpForms];
  const finalStep = forms.length - 1;

  const onStepSuccess = () => {
    if (step === finalStep) {
    } else {
      setStep(step + 1);
      smoothScrollToRef(topRef);
    }
  };

  const onLastSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
  };

  let components = forms.map((f, i) => {
    return (
      <div key={i}>
        <FormWrapper
          form={f}
          programName={programName}
          fields={f.childrenMarketoFormField}
          onSuccess={i === finalStep ? onLastSuccess : onStepSuccess}
        />
      </div>
    );
  });

  return (
    <div>
      <ScrollTo reference={topRef} className={className} />
      {components[step]}
    </div>
  );
};

Form.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default Form;
